export enum DialogResponse {
    ok,
    cancel
}
